import React, { useState, useRef } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { trans } from '../../../_providers/Translation'

//images
import loader from '../../../assets/img/loader.svg'
import popupHeadImage from '../../../assets/img/modals/icons/head.svg'
import { useNotificationsContext } from '../../../_providers/Notifications'
// import { useAuthDataContext } from '../../../_providers/Auth'
import Api from '../../../_helpers/Api'
import { enqueueSnackbar } from 'notistack'


function Notifications(props) {
    // const [statuses, setStatuses] = useState([])
    // const [selectedNotification, setSelectedNotification] = useState(null)
    // const [modalOpen, setModalOpen] = useState(false)
    const [openDropdownId, setOpenDropdownId] = useState(null)
    const [confirmModal, setConfirmModal] = useState({ overlay: false, modal: false, btn: null })
    const [cannotCloseModal, setCannotCloseModal] = useState({ overlay: false, modal: false, notificationId: null, reason: '' })
    const [disableOptions, setDisableOptions] = useState(false)

    const cannotCloseNotificationIdRef = useRef(null)

    // const auth = useAuthDataContext()

    // useEffect(() => {
    //     if (auth.isAdmin()) return

    //     Api.get('storage/statuses').then(res => {
    //         setStatuses(res.data)
    //     })
    // }, [])

    const handleNotificationClick = (notification) => {
        if (!notification.url) return

        // Mark notification as read
        if (!notification.read_at) {
            Api.post(`notifications/mark-as-read`, { id: notification.id }).then(() => {
                notifications.load()
                notifications.loadCount()
            }).catch(err => {
                console.error('Failed to mark notification as read:', err)
            })
        }

        window.location.href = notification.url
    }

    // const handleModalClose = () => {
    //     setModalOpen(false)
    //     setSelectedNotification(null)
    // }

    // const handleStatusChange = (event, notification, selectedStatusId) => {
    //     event.stopPropagation() // Prevent notification click when changing status

    //     //Get the part_id from the notification text
    //     const match = notification.text.match(/- (\d+)/)
    //     const partId = match ? match[1] : null

    //     Api.post('ordered-parts/set-new-part-status', {
    //         id: partId,
    //         status_id: selectedStatusId
    //     }).then(res => {
    //         console.log('Status updated:', res.data)
    //     }).catch(err => {
    //         console.error('Failed to update status:', err)
    //     })
    // }

    const handleButtonClick = (event, btn, notificationId) => {
        event.stopPropagation()
        setConfirmModal(prev => ({ ...prev, overlay: true, btn, notificationId }))
        setTimeout(() => setConfirmModal(prev => ({ ...prev, modal: true })), 50)
    }

    const handleConfirmClose = () => {
        setConfirmModal(prev => ({ ...prev, modal: false }))
        setTimeout(() => setConfirmModal(prev => ({ ...prev, overlay: false, btn: null })), 50)
    }

    const handleConfirmSubmit = (e) => {
        e.preventDefault()
        const { btn, notificationId } = confirmModal
        setDisableOptions(true)
        Api.post(btn.endpoint, { ...(btn.payload || {}), notification_id: notificationId })
            .then(() => {
                removeNotificationOptions(notificationId)
            })
            .catch(err => {
                console.error('Button action failed:', err)
            })
            .finally(() => {
                setDisableOptions(false)
            })
        handleConfirmClose()
    }

    function removeNotificationOptions(notificationId) {
        document.querySelector(`.notification-buttons[data-option-id="${notificationId}"]`)?.remove()
    }

    const handleSelectChange = (event, sel) => {
        event.stopPropagation()
        setDisableOptions(true)

        Api.post(sel.endpoint, {
            ...(sel.static_payload || {}),
            [sel.payload_key]: event.target.value
        })
            .then(() => {
                removeNotificationOptions(sel.notification_id)
            })
            .catch(err => {
                console.error('Select action failed:', err)
            })
            .finally(() => {
                setDisableOptions(false)
            })
    }

    const toggleDropdown = (event, id) => {
        event.stopPropagation()
        setOpenDropdownId(prev => prev === id ? null : id)
    }

    const handleCannotClose = (event, notificationId) => {
        event.stopPropagation()
        setOpenDropdownId(null)
        cannotCloseNotificationIdRef.current = notificationId
        setCannotCloseModal(prev => ({ ...prev, overlay: true, notificationId, reason: '' }))
        setTimeout(() => setCannotCloseModal(prev => ({ ...prev, modal: true })), 50)

        Api.get(`notifications/${notificationId}/deny-reason`)
            .then(res => {
                setCannotCloseModal(prev => ({ ...prev, reason: res.data.deny_reason || '' }))
            })
            .catch(() => { })
    }

    const handleCannotCloseClose = () => {
        setCannotCloseModal(prev => ({ ...prev, modal: false }))
        setTimeout(() => setCannotCloseModal(prev => ({ ...prev, overlay: false, notificationId: null })), 50)
    }

    const handleCannotCloseSubmit = (e) => {
        e.preventDefault()
        const { reason } = cannotCloseModal
        const notificationId = cannotCloseNotificationIdRef.current
        setDisableOptions(true)

        Api.post(`notifications/${notificationId}/deny`, { reason }).then(() => {
            enqueueSnackbar(
                trans('messages.changesSavedSuccessfully'),
                {
                    variant: "success",
                },
            )

            removeNotificationOptions(notificationId)
        })
            .catch(err => {
                console.error('Cannot close submit failed:', err)
            })
            .finally(() => {
                setDisableOptions(false)
            })

        handleCannotCloseClose()
    }

    const notifications = useNotificationsContext()
    console.log('Notifications: ' + JSON.stringify(notifications))

    const ref = useRef(null)

    return (
        <>
            <form className={`${confirmModal.overlay ? 'visible' : ''} overlay`} onSubmit={handleConfirmSubmit}>
                <div className={`${confirmModal.modal ? 'show' : ''} popup-primary large`}>
                    <div className="head-new">
                        <img src={popupHeadImage} alt="" />
                        <div className="texts">
                            <h2>{trans('notifications.confirm_close_title')}</h2>
                            <p>{trans('notifications.confirm_close_subtitle')}</p>
                        </div>
                        <span className="close" onClick={handleConfirmClose} />
                    </div>
                    <div className="popup-container">
                        <div className="col">
                            <p>{trans('notifications.confirm_close_message')}</p>
                        </div>
                    </div>
                    <div className="footer align-right">
                        <button className="button button-primary" type="submit">
                            {trans('buttons.confirm')}
                        </button>
                        <button type="button" onClick={handleConfirmClose}>
                            {trans('buttons.cancel')}
                        </button>
                    </div>
                </div>
            </form>

            <form className={`${cannotCloseModal.overlay ? 'visible' : ''} overlay`} onSubmit={handleCannotCloseSubmit}>
                <div className={`${cannotCloseModal.modal ? 'show' : ''} popup-primary large`}>
                    <div className="head-new">
                        <img src={popupHeadImage} alt="" />
                        <div className="texts">
                            <h2>{trans('notifications.cannot_close_reason_title')}</h2>
                            <p>{trans('notifications.cannot_close_reason_subtitle')}</p>
                        </div>
                        <span className="close" onClick={handleCannotCloseClose} />
                    </div>
                    <div className="popup-container">
                        <div className="col">
                            <label>{trans('labels.content')}*</label>
                            <textarea
                                name="reason"
                                placeholder={trans('notifications.cannot_close_reason_placeholder')}
                                value={cannotCloseModal.reason}
                                onChange={e => setCannotCloseModal(prev => ({ ...prev, reason: e.target.value }))}
                            />
                        </div>
                    </div>
                    <div className="footer align-right">
                        <button className="button button-primary" type="submit" disabled={!cannotCloseModal.reason.trim()}>
                            {trans('buttons.save')}
                        </button>
                        <button type="button" onClick={handleCannotCloseClose}>
                            {trans('buttons.cancel')}
                        </button>
                    </div>
                </div>
            </form>

            <div className={`show messages-module`}>
                <div className="head">
                    {trans('headings.notifications')}
                </div>
                <div className="body">
                    <div className="scroll" ref={ref}>
                        {notifications.list.length === 0
                            ?
                            <p className="no-data">{trans('messages.noNotifications')}</p>
                            :
                            <InfiniteScroll
                                element="ul"
                                initialLoad={false}
                                pageStart={notifications.page}
                                loadMore={notifications.load}
                                hasMore={notifications.hasMore}
                                loader={<img key="loader" src={loader} alt="loading" />}
                                useWindow={false}
                                getScrollParent={() => ref.current}
                            >

                                {notifications.list.map(el =>
                                    <li
                                        key={el.id}
                                        onClick={() => handleNotificationClick(el)}
                                        style={{ cursor: el.url ? 'pointer' : 'default' }}
                                        className={!el.read_at ? 'unread' : ''}
                                    >
                                        <time className="timer" data-date={el.date}>
                                            {el.date_text}
                                        </time>
                                        <h3>
                                            {el.text || '-'}
                                        </h3>
                                        {/* <p>
                                            
                                        </p> */}

                                        {el.options?.buttons?.length > 0 && (
                                            <div className={`notification-buttons ${disableOptions ? 'disabled' : ''}`} data-option-id={el.id} onClick={e => e.stopPropagation()}>
                                                {el.options.buttons.map((btn, i) => (
                                                    <div key={i} style={{ position: 'relative', display: 'inline-block' }}>
                                                        <button
                                                            className={`button button-small button-success with-dropdown`}
                                                            onClick={e => handleButtonClick(e, btn, el.id)}
                                                        >
                                                            {trans(btn.label)}
                                                            <i onClick={e => toggleDropdown(e, `${el.id}-${i}`)} />
                                                        </button>
                                                        {openDropdownId === `${el.id}-${i}` && (
                                                            <div className="notification-dropdown" onClick={e => e.stopPropagation()}>
                                                                <button onClick={e => handleCannotClose(e, el.id)}>
                                                                    {trans('notifications.deny_to_close')}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        {el.options?.selects?.length > 0 && (
                                            <div className="notification-selects" onClick={e => e.stopPropagation()}>
                                                {el.options.selects.map((sel, i) => (
                                                    <select
                                                        key={i}
                                                        defaultValue={sel.current_value}
                                                        onChange={e => handleSelectChange(e, sel)}
                                                    >
                                                        {sel.options.map(opt => (
                                                            <option key={opt.id} value={opt.id}>
                                                                {opt.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                ))}
                                            </div>
                                        )}
                                    </li>
                                )}

                            </InfiniteScroll>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Notifications
